import arrow from './arrow.js'
import add from './add.js'
import chevron from './chevron.js'
import bag from './bag.js'
import remove from './remove.js'
import language from './language.js'
import shield from './shield.js'
import warning from './warning.js'
import info from './info.js'
import play from './play.js'
import pause from './pause.js'

export default {
  arrow: arrow,
  add: add,
  chevron: chevron,
  bag: bag,
  remove: remove,
  language: language,
  shield: shield,
  warning: warning,
  info: info,
  play: play,
  pause: pause,
} as const
